export default {
  "initial.centerLabel.centerLabel.text.appearing": function initialCenterLabelCenterLabelTextAppearing(a) {
    if (a.attr) return [{
      initialAttr: {
        x: a.attr.x,
        y: a.attr.y
      }
    }];
  }
};